export interface NewsItem {
  id: string;
  title: string;
  date: string;
  category: string;
  summary: string;
  content: string[];
  cover: string;
  tags: string[];
}

export const newsList: NewsItem[] = [
  {
    id: "wind-valley-announce",
    title: "濑户环奈确认主演 2026 年新片《风之谷》",
    date: "2026-03-18",
    category: "官方公告",
    summary: "官方正式公布濑户环奈将主演 2026 年上映的电影《风之谷》，并释出先导预告与主视觉海报。",
    content: [
      "官方于今日正式宣布，濑户环奈将主演计划于 2026 年上映的电影《风之谷》。这是她继《海边的信》之后再度挑战文学性与自然主题兼具的作品。",
      "在先导预告中，濑户环奈以自然素雅的造型出现在一片被晨雾笼罩的山谷之中，影片的奇幻世界观与清新视觉风格引发粉丝热烈讨论。制作团队透露，影片自三年前便已启动筹备。",
      "濑户环奈在官方评论中表示：“这是一个关于守护与重生的故事，我很期待能把它带到大家面前。”影片的具体上映日期将于后续公布。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20with%20long%20dark%20hair%20at%20a%20formal%20press%20announcement%20event%2C%20soft%20warm%20lighting%2C%20neutral%20cream%20tones%2C%20editorial%20documentary%20photography%2C%20high%20detail&width=1600&height=900&seq=news-01-cover&orientation=landscape",
    tags: ["官方公告", "电影", "风之谷"],
  },
  {
    id: "tokyo-film-festival",
    title: "濑户环奈亮相东京国际电影节红毯",
    date: "2025-10-25",
    category: "活动报道",
    summary: "濑户环奈身着高级定制礼服出席东京国际电影节开幕式红毯，成为全场焦点之一。",
    content: [
      "第若干届东京国际电影节于昨晚隆重开幕，濑户环奈一袭优雅礼服亮相红毯，吸引了全场媒体的镜头。她此行是为参展作品《海边的信》站台。",
      "红毯现场，濑户环奈与导演及合作演员共同接受采访，分享了影片拍摄期间的难忘经历。她表示海边的拍摄虽然辛苦，却留下了极其珍贵的回忆。",
      "当晚濑户环奈的造型被评为红毯最佳着装之一，相关话题迅速登上社交平台热搜榜。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20in%20an%20elegant%20gown%20on%20a%20film%20festival%20red%20carpet%20surrounded%20by%20photographers%2C%20warm%20event%20lighting%2C%20glamorous%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-02-cover&orientation=landscape",
    tags: ["活动报道", "电影节", "红毯"],
  },
  {
    id: "sea-letter-interview",
    title: "《海边的信》幕后专访：濑户环奈谈角色塑造",
    date: "2025-08-12",
    category: "媒体采访",
    summary: "濑户环奈接受杂志专访，深入分享在《海边的信》中如何用眼神与沉默完成表演。",
    content: [
      "在新片《海边的信》上映之际，濑户环奈接受了本刊的深度专访。谈到这次的表演，她说最难的部分是“把不需要说的话藏起来”。",
      "“导演希望我尽量少用台词，让观众从我的表情和呼吸里去感受角色的变化。”濑户环奈坦言，这对习惯了用台词表达的她是一次全新的挑战。",
      "当被问及未来的目标时，她笑着说希望能尝试更多不同类型的角色，尤其是那些“看起来离自己很远的人”。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20with%20long%20dark%20hair%20during%20a%20magazine%20interview%20sitting%20in%20a%20warm%20lit%20studio%2C%20soft%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-03-cover&orientation=landscape",
    tags: ["媒体采访", "海边的信", "表演"],
  },
  {
    id: "2025-plan",
    title: "濑户环奈公布 2025 年度工作计划",
    date: "2025-01-06",
    category: "官方公告",
    summary: "新年伊始，濑户环奈通过官方渠道公布 2025 年度的工作计划与新作品安排。",
    content: [
      "新年伊始，濑户环奈通过官方粉丝平台公布了 2025 年度的工作计划。她将在今年带来一部电影与一部电视剧作品，并计划参与若干线下活动。",
      "官方公告显示，《海边的信》将于年内上映，而电视剧《银座之夜》也已进入后期制作阶段。此外，她还将在多个城市举行粉丝见面活动。",
      "濑户环奈在公告中向粉丝送上新年祝福：“感谢大家过去一年的支持，新的一年请继续多多关照。”",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20with%20long%20dark%20hair%20smiling%20in%20a%20bright%20minimal%20studio%20setting%2C%20soft%20warm%20lighting%2C%20cream%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-04-cover&orientation=landscape",
    tags: ["官方公告", "年度计划"],
  },
  {
    id: "ginza-premiere",
    title: "濑户环奈出席《银座之夜》首映礼",
    date: "2025-05-20",
    category: "活动报道",
    summary: "电视剧《银座之夜》举行首映礼，濑户环奈与合作演员一同亮相，分享拍摄幕后。",
    content: [
      "话题剧集《银座之夜》昨晚举行首映礼，濑户环奈身着剧中同款风格的礼服登场，一现身便引来现场粉丝的欢呼。",
      "在映后交流环节，濑户环奈与木村拓哉等主创一同回顾了拍摄期间的点滴。她透露为了演好老板娘这个角色，自己特意去银座的店铺观察学习了很久。",
      "《银座之夜》将于下周正式开播，目前预约观看人数已创下平台纪录。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20in%20an%20elegant%20dress%20at%20a%20tv%20drama%20premiere%20event%20with%20photographers%2C%20warm%20glamorous%20lighting%2C%20rose%20and%20gold%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-05-cover&orientation=landscape",
    tags: ["活动报道", "银座之夜", "首映礼"],
  },
  {
    id: "magazine-cover",
    title: "濑户环奈时尚写真与专访登上杂志封面",
    date: "2025-07-03",
    category: "媒体采访",
    summary: "濑户环奈成为知名时尚杂志封面人物，并接受专访畅谈对表演与生活的理解。",
    content: [
      "濑户环奈近日登上知名时尚杂志封面，一组以“四季”为主题的写真引发广泛关注。摄影师用自然光影勾勒出她气质中柔软而坚韧的一面。",
      "在随刊专访中，濑户环奈谈到了自己对于“演员”这个身份的思考。她说：“表演让我有机会去理解很多原本不会理解的人。”",
      "谈到生活，她表示自己最爱在休息日做饭与读书，这些安静的时光帮助她重新积蓄能量。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20with%20long%20dark%20hair%20in%20a%20fashion%20magazine%20photo%20shoot%20with%20soft%20directional%20light%2C%20elegant%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-06-cover&orientation=landscape",
    tags: ["媒体采访", "时尚", "杂志"],
  },
  {
    id: "fan-club-open",
    title: "濑户环奈开设官方粉丝俱乐部",
    date: "2024-12-01",
    category: "官方公告",
    summary: "濑户环奈官方粉丝俱乐部正式上线，会员可获取第一手资讯与限定内容。",
    content: [
      "濑户环奈官方粉丝俱乐部于今日正式上线。俱乐部将提供第一手资讯、活动优先参与资格以及限定花絮内容。",
      "官方表示，粉丝俱乐部是她与支持者之间更近距离交流的空间，未来将持续更新幕后故事与生活分享。",
      "开业当日，俱乐部收到了来自各地粉丝的大量注册请求，官方特别感谢大家的支持与等待。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20with%20long%20dark%20hair%20waving%20at%20fans%20in%20a%20bright%20modern%20space%2C%20soft%20warm%20lighting%2C%20cream%20and%20pink%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-07-cover&orientation=landscape",
    tags: ["官方公告", "粉丝俱乐部"],
  },
  {
    id: "charity-gala",
    title: "濑户环奈参与慈善义演为灾区筹款",
    date: "2024-09-14",
    category: "活动报道",
    summary: "濑户环奈出席慈善义演活动，为受灾地区筹募善款并呼吁社会关注。",
    content: [
      "濑户环奈于昨晚出席一场慈善义演活动，为近期受灾地区筹募善款。她在活动中献唱一曲，并参与现场募捐环节。",
      "她在台上表示：“希望能尽自己的一份力，也希望大家都能伸出援手。”整场活动共筹得善款将全部用于灾后重建。",
      "活动结束后，濑户环奈还在社交平台转发相关公益信息，呼吁更多人关注灾区的情况。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20speaking%20on%20stage%20at%20a%20charity%20event%20with%20warm%20stage%20lighting%2C%20soft%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-08-cover&orientation=landscape",
    tags: ["活动报道", "公益", "慈善"],
  },
  {
    id: "light-shadow-bts",
    title: "濑户环奈分享《光影之间》拍摄花絮",
    date: "2024-06-22",
    category: "媒体采访",
    summary: "濑户环奈在采访中分享《光影之间》片场的趣事，以及角色带给她的成长。",
    content: [
      "在《光影之间》热播之际，濑户环奈接受了媒体采访，回忆起片场那些忙碌而充实的日子。她说：“每天都在和光打交道。”",
      "为了演好摄影师这个角色，她系统学习了摄影基础知识，还在片场亲自掌镜拍摄了不少素材。她笑称自己“差点转行”。",
      "谈到角色带来的影响，她表示这段经历让她对整个影视行业有了更深的敬意，也更加珍惜每一份幕后工作。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20with%20a%20camera%20on%20a%20film%20set%20in%20a%20relaxed%20behind%20the%20scenes%20moment%2C%20warm%20amber%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-09-cover&orientation=landscape",
    tags: ["媒体采访", "光影之间", "花絮"],
  },
  {
    id: "newcomer-award",
    title: "濑户环奈荣获年度新人女演员奖",
    date: "2023-11-30",
    category: "官方公告",
    summary: "濑户环奈凭借《东京往事》中的出色表现荣获年度新人女演员奖，首次获得行业重要肯定。",
    content: [
      "在昨晚举行的年度影视大奖颁奖典礼上，濑户环奈凭借电影《东京往事》中的表演荣获年度新人女演员奖，这是她职业生涯中首个重要表演奖项。",
      "登台领奖时，濑户环奈一度哽咽。她感谢导演与剧组全体成员，也感谢一路支持她的家人与观众。",
      "业内人士认为，这个奖项是对她多年来努力的最好回报，也预示着更广阔的可能性。",
    ],
    cover: "https://readdy.ai/api/search-image?query=young%20Japanese%20woman%20holding%20a%20glass%20award%20trophy%20on%20a%20stage%20at%20an%20awards%20ceremony%2C%20warm%20stage%20lighting%2C%20gold%20and%20neutral%20tones%2C%20editorial%20photography%2C%20high%20detail&width=1600&height=900&seq=news-10-cover&orientation=landscape",
    tags: ["官方公告", "获奖", "东京往事"],
  },
];